import React, { Component } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";

class Header extends Component {
  render() {
    return (
      <Navbar className='justify-content-center nav' expand='lg' sticky='top'>
        <Navbar.Brand href='#home'>
          <img
            alt=''
            src={`${process.env.PUBLIC_URL}/nodeschool.png`}
            width='30'
            height='30'
            className='d-inline-block align-top'
          />
          {"NodeSchool Madison"}
        </Navbar.Brand>
        <Nav>
          {
            // <Nav.Link href='#home'>Home</Nav.Link>
            // <Nav.Link href='#link'>Schedule</Nav.Link>
            //   <NavDropdown title='Dropdown' id='basic-nav-dropdown'>
            //   <NavDropdown.Item href='#action/3.1'>Action</NavDropdown.Item>
            //   <NavDropdown.Item href='#action/3.2'>
            //     Another action
            //   </NavDropdown.Item>
            //   <NavDropdown.Item href='#action/3.3'>Something</NavDropdown.Item>
            //   <NavDropdown.Divider />
            //   <NavDropdown.Item href='#action/3.4'>
            //     Separated link
            //   </NavDropdown.Item>
            // </NavDropdown>
          }
        </Nav>
      </Navbar>
    );
  }
}

export default Header;
